export const DOCS_INTEGRATION_BASE = 'https://docs.secoda.com/integrations/';
export const DOCS_EXTENSION_BASE = 'https://docs.secoda.com/extensions/';
